import * as formlabsComponents from './components';
import NotFound from './components/errors/NotFound';

import commonComponents from '../../common/components/commonComponents';

export default {
  '404': NotFound,
  ...commonComponents,
  ...formlabsComponents
};
